<template>
  <div class="home">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <clientNavSelector></clientNavSelector>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/requests` }">Requests</el-breadcrumb-item>
      <el-breadcrumb-item>New Interim Service Request
      </el-breadcrumb-item>
    </el-breadcrumb>
    <hia-loading v-if="loading"></hia-loading>
    <div v-if="!loading">
      <el-row :gutter="40" style="margin-top: 40px;">
        <el-col :span="5">
          <div>
            <el-steps id="requestSteps" direction="vertical" :active="activeStep" finish-status="success">
              <el-step title="Request Basics">
                <div slot="description">
                  <p>Please select Interim Date Range.</p>
                  <p> For scheduling requests within 14 days, please
                    contact HIA directly.</p>
                </div>
              </el-step>
              <el-step title="Add Consultants">
                <div slot="description">
                  <p>Use the top section to add consultants to your interim request.</p>
                  <p>Once you have added consultants to the request, you can add additional information in the bottom
                    section.
                  </p>
                </div>
              </el-step>
              <el-step title="Confirm">
                <div slot="description">
                  <p>Confirm your request and choose Submit Request to send to HIA.</p>
                </div>
              </el-step>
            </el-steps>
          </div>
        </el-col>
        <el-col :span="19">

          <transition name="fade" mode="out-in">
            <!-- Step 0 -->
            <div key="step0" v-if="activeStep === 0">
              <el-form label-position="top" ref="newInterimRequest" :rules="newInterimRequest.rules" :model="newInterimRequest" @submit.prevent.native>
                <!-- <el-form-item label="Coding Type">
                  <el-radio-group v-model="newInterimRequest.serviceLine">
                    <el-radio label="Acute">Acute</el-radio>
                    <el-radio label="Professional Fee">Professional Fee</el-radio>
                  </el-radio-group>
                </el-form-item> -->
                <el-form-item prop="interimType" label="Interim Type">
                  <el-checkbox-group v-model="newInterimRequest.interimType">
                    <el-checkbox label="Acute">Acute</el-checkbox>
                    <el-checkbox label="Professional Fee">Professional Fee</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>

                <el-form-item prop="dateRange" label="Requested Interim Dates">
                  <el-date-picker v-model="newInterimRequest.dateRange" type="daterange" range-separator="To" start-placeholder="Start date" end-placeholder="End date" :picker-options="dateRangeOptions" format="MM/dd/yyyy" value-format="MM/dd/yyyy">
                  </el-date-picker>
                </el-form-item>
              </el-form>

              <el-button type="primary" id="next" style="margin-top: 20px;" @click="completeStepZero">Next <i style="padding-left: 5px;" class="el-icon-arrow-down"></i>
              </el-button>
              <hia-loading style="margin-top: 40px;" v-if="submitting"></hia-loading>

            </div>

            <!-- Step 1 -->
            <div key="step1" v-if="activeStep === 1">
              <h4 class="heading">Set Consultants and Add Notes
              </h4>
              <el-form label-position="top" ref="newInterimRequestStep1" :rules="newInterimRequest.rules" :model="newInterimRequest" @submit.prevent.native>
                <el-form-item prop="numberConsultants" label="Number of Consultants" style="width: 90%;">
                  <el-input-number v-model="newInterimRequest.numberConsultants" :min="0"></el-input-number>
                </el-form-item>

                <el-form-item prop="notes" label="Additional Notes">
                  <el-input type="textarea" :rows="4" placeholder="Notes" v-model="newInterimRequest.notes">
                  </el-input>
                </el-form-item>
              </el-form>

              <el-button plain style="margin-top: 30px; margin-bottom: 20px" @click="modifyPrevious">
                Modify Previous <i style="padding-left: 5px;" class="el-icon-arrow-up"></i>
              </el-button>

              <el-button title="Add consultants before moving to the next step" type="primary" :disabled="newInterimRequest.numberConsultants === 0" style="margin-top: 30px;" @click="completeStepOne">
                Next <i style="padding-left: 5px;" class="el-icon-arrow-down"></i>
              </el-button>
            </div>

            <!-- Step 2 -->
            <div key="step2" v-if="activeStep === 2">
              <h4 class="heading">Please Confirm Interim Request
              </h4>

              <el-row>
                <el-col :span="4">
                  <span class="demoTitle">Interim Type:</span>
                </el-col>
                <el-col :span="8">
                  <span class="demoData">{{newInterimRequest.interimType.length > 1 ? `${newInterimRequest.interimType[0]} / ${newInterimRequest.interimType[1]}`  : newInterimRequest.interimType[0]}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">
                  <span class="demoTitle">Interim Dates:</span>
                </el-col>
                <el-col :span="8">
                  <span class="demoData">starting {{newInterimRequest.dateRange[0]}} and ending
                    {{newInterimRequest.dateRange[1]}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">
                  <span class="demoTitle">Consultants:</span>
                </el-col>
                <el-col :span="8">
                  <span class="demoData">{{newInterimRequest.numberConsultants}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">
                  <span class="demoTitle">Additional Notes:</span>
                </el-col>
                <el-col :span="20">
                  <span class="demoData">{{newInterimRequest.notes}}</span>
                </el-col>
              </el-row>

              <el-button plain style="margin-top: 30px; margin-bottom: 20px" @click="modifyPrevious">
                Modify Previous <i style="padding-left: 5px;" class="el-icon-arrow-up"></i>
              </el-button>

              <el-button type="primary" style="margin-top: 30px;" @click="completeStepTwo">
                Submit Request
              </el-button>
              <br />
              <hia-loading style="margin-top: 40px;" v-if="submitting"></hia-loading>
            </div>
            <!-- Step 3 -->
            <div key="step3" v-if="activeStep === 3">
              <h4>Thank you, we have received your request. We will review and confirm the availability of our staff. A
                final
                schedule will be sent prior to the start date.</h4>
              <router-link :to="`/${currentClientId}/requests`">
                <el-button type="primary">Return to Request List</el-button>
              </router-link>
            </div>
          </transition>

        </el-col>
        <el-col :span="4">
          <ul class="actionButtons" style="margin-top: 0">
            <li>
              <!-- <el-button type="primary">New Request</el-button> -->
            </li>
          </ul>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    data: function () {
      return {
        dateRangeOptions: {
          disabledDate(time) {
            let today = new Date(Date.now() - (24 * 60 * 60 * 1000))
            return time.getTime() < today.getTime()
          }
        },
        activeStep: 0,
        loading: true,
        submitting: false,
        newInterimRequest: {
          dateRange: [],
          numberConsultants: 0,
          interimType: ['Acute'],
          notes: '',
          rules: {
            interimType: [
              { required: true, message: 'Please Select Interim Type', trigger: 'change' }
            ],
            dateRange: [
              { required: true, message: 'Please Select Date Range', trigger: 'change' }
            ],
            numberConsultants: [
              { required: true, message: 'Please Select Number of Consultants', trigger: 'change' }
            ]
          }
        }
      }
    },
    name: 'NewInterimRequest',
    methods: {
      ...mapActions('requests/interim', ['CHECK_EXISTS', 'POST_INTERIM_SCHEDULE_REQUEST']),
      initialize() {
        this.loading = false
      },
      completeStepZero() {
        this.$refs['newInterimRequest'].validate((valid) => {
          if (valid) {
            this.activeStep++
          }
        })
      },
      modifyPrevious() {
        if (this.activeStep === 1 && this.newInterimRequest.numberConsultants > 0) {
          this.$confirm(`This will clear all coders from your request, continue?`, 'Modify previous', {
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.newInterimRequest.numberConsultants = 0
            this.activeStep--
          })
        } else {
          this.activeStep--
        }
        window.scrollTo(0, 0)
      },
      completeStepOne() {
        this.activeStep++
        window.scrollTo(0, 0)
      },
      completeStepTwo() {
        this.submitting = true
        let payload = this.newInterimRequest

        this.POST_INTERIM_SCHEDULE_REQUEST(payload).then(() => {
          this.activeStep++
          this.submitting = false
        }, error => {
          let message = error.response.data ? error.response.data.message : error
          this.$message({
            type: 'error',
            message: message,
            duration: 10000
          })
          this.submitting = false
        })
      }
    },
    created: function () {
      this.initialize()
    },
    computed: {
      ...mapState('user/', ['currentClient', 'currentClientId'])
    }
  }
</script>

<style scoped>
>>> tr .cell {
  font-weight: 500;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ACTION BUTTONS */
.actionButtonsIcon {
  font-size: 18px;
}

/* EL STEPS */
#requestSteps {
  background: rgba(238, 238, 238, 0.5);
  border-radius: 5px;
  padding: 5px 2px 5px 2px;
}

#requestSteps >>> .el-step {
  /* min-height: 150px; */
  flex-basis: auto !important;
}

#requestSteps >>> .el-step__main {
  padding-bottom: 10px;
}

/* step waiting*/
#requestSteps >>> .el-step__description.is-wait {
  padding-right: 0px;
}

#requestSteps >>> .el-step__description.is-wait p {
  margin: 0px 0px 10px 0px !important;
  font-weight: normal !important;
  padding-right: 0px;
}

/* step in process*/
#requestSteps >>> .el-step__description.is-process {
  padding-right: 0px;
}

#requestSteps >>> .el-step__description.is-process p {
  margin: 0px 0px 10px 0px;
  padding-right: 0px;
  font-weight: normal !important;
  color: #606266;
}

#requestSteps >>> .el-step__title.is-process,
#requestSteps >>> .el-step__head.is-process {
  color: #005695;
}

#requestSteps >>> .el-step__head.is-process .el-step__line {
  background-color: #005695;
}

#requestSteps >>> .el-step__head.is-process .el-step__icon.is-text {
  border: 2px solid #005695;
}

/* step success */
#requestSteps >>> .el-step__description.is-success {
  padding-right: 0px;
}

#requestSteps >>> .el-step__description.is-success p {
  margin: 0px 0px 10px 0px;
  padding-right: 0px;
  font-weight: normal !important;
  color: #c0c4cc;
}

#requestSteps >>> .el-step__title.is-success,
#requestSteps >>> .el-step__head.is-success {
  color: #7cbe5f;
}

#requestSteps >>> .el-step__head.is-success .el-step__line {
  background-color: #7cbe5f;
}

#requestSteps >>> .el-step__head.is-success .el-step__icon.is-text {
  border: 2px solid #7cbe5f;
}

/* ADD CALEDNAR */
.addCalendar >>> .el-form-item__content {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 0px 0px 15px 0px;
}

/* request button */
.requestButton {
  font-size: 12px;
  font-weight: 500;
}

.requestButtonIcons {
  font-size: 22px;
  float: right;
  margin: -5px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  height: 14px;
  width: 14px;
}

>>> .cell {
  word-break: inherit !important;
}

>>> .el-table__empty-block {
  min-height: 39px;
}

>>> .table-list {
  display: table-cell;
  vertical-align: middle;
  list-style-type: none;
  padding: 0px;
}

.demoData {
  color: #606266;
  font-size: 14px;
  word-wrap: break-word;
}
</style>
